(function() {
  function refreshHotPreorderSection() {
    var sectionId = 'template--20151597301869__featured_collection_aAWVmF';
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section || section.querySelector('.bgtcg-qty-wrap') || window.__bgtcgHotPreorderRefresh) return;

    window.__bgtcgHotPreorderRefresh = true;
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(payload) {
        var html = payload && payload[sectionId];
        if (!html) return;

        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var freshSection = wrapper.querySelector('#shopify-section-' + sectionId);
        if (freshSection && freshSection.querySelector('.bgtcg-qty-wrap')) section.replaceWith(freshSection);
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshHotPreorderSection);
  } else {
    refreshHotPreorderSection();
  }

  var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  if (!isMobile) return;

  function isOnePieceSingleCollection(url) {
    return url.origin === window.location.origin && url.pathname.indexOf('/collections/op-') === 0;
  }

  function liteUrl(url) {
    return url.pathname + '?view=mobile-lite' + (url.hash || '');
  }

  function rewriteLinks(root) {
    root = root || document;
    root.querySelectorAll('a[href]').forEach(function(link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (isOnePieceSingleCollection(url) && url.searchParams.get('view') !== 'mobile-lite') {
          link.setAttribute('href', liteUrl(url));
        }
      } catch (error) {}
    });
  }

  try {
    var current = new URL(window.location.href);
    if (isOnePieceSingleCollection(current) && current.searchParams.get('view') !== 'mobile-lite') {
      window.location.replace(liteUrl(current));
      return;
    }
  } catch (error) {}

  rewriteLinks();

  document.addEventListener('click', function(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      if (isOnePieceSingleCollection(url) && url.searchParams.get('view') !== 'mobile-lite') {
        event.preventDefault();
        window.location.assign(liteUrl(url));
      }
    } catch (error) {}
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteLinks);
  } else {
    setTimeout(rewriteLinks, 0);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) rewriteLinks(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
